import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../land-use-change-agreement.routes';
import { LandUseChangeAgreementLocalisationDataForm } from './forms/land-use-change-agreement-localisation-data.form';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ExposedMapControlComponent
} from '../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { RoadControlsSetComponent } from '../../../common/components/road-controls-set/road-controls-set.component';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-land-use-change-agreement-localisation-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    ExposedMapControlComponent,
    RoadControlsSetComponent,
    ParcelsCrudComponent,
    CommonModule,
    ValidationErrorsComponent
  ],
  providers: [LandUseChangeAgreementLocalisationDataForm],
  templateUrl: './land-use-change-agreement-localisation-data-section.component.html'
})
export class LandUseChangeAgreementLocalisationDataSectionComponent implements OnDestroy {

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public form: LandUseChangeAgreementLocalisationDataForm = inject(LandUseChangeAgreementLocalisationDataForm);

  public stages: string[] = stages;

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchApplication: Subscription = toObservable(this.application).subscribe((app) => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateParcels({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcelsValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
